import { intersection } from 'es-toolkit';

export const OKTA_GROUPS = {
  STREAMING_ADMIN: 'Streaming Admin',
  STREAMING_CUSTOMER_SUPPORT: 'Streaming Customer Support',
  STREAMING_DEVELOPER: 'Streaming Developer',
  STREAMING_MEDIA_OPERATORS: 'Streaming Media Operators',
  STREAMING_POLICY_ADMIN: 'Streaming Policy Admin',
  STREAMING_POLICY_MANAGER: 'Streaming Policy Manager',
  STREAMING_PRODUCT_MANAGER: 'Streaming Product Manager',
  STREAMING_STREAMING_LOGGER: 'Streaming Logger',
  STREAMING_VIEWER: 'Streaming Viewer',
} as const;

export type OktaGroup = (typeof OKTA_GROUPS)[keyof typeof OKTA_GROUPS];

export const isAuthorized = (allowedGroups: string[], userGroups: string[]) => {
  if (allowedGroups.length === 0) return true;

  return allowedGroups.some((group) => userGroups.includes(group));
};

/**
 * Read-only when the user has Streaming Viewer and does not have any other group from `allowedGroups`.
 * Other Okta groups (e.g. unrelated app roles) are ignored — only membership in `allowedGroups` matters.
 * Example: Viewer + Streaming Admin → not read-only; Viewer + only non-tool groups → read-only.
 */
export const isStreamingViewOnly = (allowedGroups: string[], userGroups: string[]) => {
  if (!userGroups.includes(OKTA_GROUPS.STREAMING_VIEWER)) return false;

  const toolGroups = intersection(userGroups, allowedGroups);
  return !toolGroups.some((group) => group !== OKTA_GROUPS.STREAMING_VIEWER);
};
